import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

import TireListingView from "../list/TireListingView";

const styles = (theme) => ({
  header: {
    marginBottom: theme.spacing(3),
  },
  title: {
    marginTop: theme.spacing(0.5),
  },
  description: {
    marginTop: theme.spacing(1),
  },
  emptyState: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 12,
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(4),
    textAlign: "center",
  },
  emptyText: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
});

class CategoryResultsPage extends React.Component {
  componentDidMount() {
    this.ensureCategoryLoaded();
    window.scrollTo(0, 0);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.category !== this.props.match.params.category) {
      this.ensureCategoryLoaded();
      window.scrollTo(0, 0);
    }
  }

  ensureCategoryLoaded() {
    const { category } = this.props.match.params;
    if (this.props.catalog.motoTiresQueryKey !== `category:${category}`) {
      this.props.actions.setListPending(true);
      this.props.actions.searchMotoTiresByCategory(category);
    }
  }

  renderHeader(category, seo) {
    const { classes } = this.props;
    const heading = (seo.title || category.name || "מבצעי צמיגים").replace(/\s*-\s*ספורטישופ\s*$/, "");

    return (
      <header className={classes.header}>
        <Typography variant="overline" color="textSecondary">
          צמיגים לאופנוע · קטגוריה
        </Typography>
        <Typography variant="h4" component="h1" className={classes.title}>
          {heading}
        </Typography>
        {seo.description ? (
          <Typography variant="body2" color="textSecondary" className={classes.description}>
            {seo.description}
          </Typography>
        ) : null}
      </header>
    );
  }

  renderEmpty() {
    const { classes } = this.props;

    return (
      <div className={classes.emptyState}>
        <Typography variant="h6" component="h2">
          אין כרגע מוצרים בקטגוריה זו
        </Typography>
        <div className={classes.emptyText}>
          <Button component={Link} to="/" variant="outlined" color="primary">
            חזרה לחיפוש
          </Button>
        </div>
      </div>
    );
  }

  render() {
    const { catalog, actions, match } = this.props;
    const categoryId = match.params.category;
    const queryKey = `category:${categoryId}`;
    const loaded = catalog.motoTiresQueryKey === queryKey;
    const category = (loaded && catalog.category) || {};
    const seo = category.seo || {};
    const metaTitle = seo.title || "מבצעי צמיגים בספורטישופ!";
    const metaDesc =
      seo.description ||
      "מגוון רחב של צמיגים " +
        " תוכלו למצוא אצלנו במגוון מותגים מובילים - עד 70% הנחה - פירלי, מישלין, מצלר, קונטיננטל, ברידגסטון ועוד";

    return (
      <React.Fragment>
        <Helmet>
          <meta property="og:title" content={metaTitle} />
          <meta property="og:description" content={metaDesc} />
          <meta property="description" content={metaDesc} />
          <title>{metaTitle}</title>
        </Helmet>
        <TireListingView
          header={this.renderHeader(category, seo)}
          products={Array.isArray(catalog.motoTires) ? catalog.motoTires : []}
          pending={catalog.listPending || catalog.motoTiresQueryKey !== queryKey}
          emptyState={this.renderEmpty()}
          availabilityContext={{
            currentShipment: catalog.currentShipment,
            nextShipment: catalog.nextShipment,
            euContainerMode: catalog.euContainerMode,
          }}
          limitedTimeOffers={catalog.limitedTimeOffers || []}
          addProductsToCart={actions.addProductsToCart}
          collectMetric={actions.collectMetric}
          metricSource="list_page_by_category"
          resetKey={queryKey}
        />
      </React.Fragment>
    );
  }
}

CategoryResultsPage.propTypes = {
  classes: PropTypes.object.isRequired,
  actions: PropTypes.object,
  catalog: PropTypes.object.isRequired,
  match: PropTypes.object,
};

export default withStyles(styles)(CategoryResultsPage);
